import React, { useEffect, useState } from "react";
import { OrdersToolbarProps } from "../../../../shared/services/interface";
import SearchField from "./SearchField";
import ImportButton from "./ImportButton";
import ExportSelect from "./ExportSelect";
import FilterSelect from "./FieldSelect";
import CustomDropdownSelect from "src/business-types/grocery/components/DropdownSelect";

export const STATUS_OPTIONS = ["Confirm", "In-process", "Waiting for delivery", "Delivered", "Cancelled"];


const OrdersToolbar: React.FC<OrdersToolbarProps> = ({
  searchTerm,
  handleSearch,
  inputRef,
  handleImport,
  handleExport,
  orders,
  selectedDate,
  selectedDate2,
  selectedOption,
  handleFilterChange,
  statusFilter = "", // ✅ Add with default
  onStatusFilterChange = () => {}, // ✅ Add with default
}) => {
  // ✅ Local state for status filter (optional, or use prop directly)
  const [localStatusFilter, setLocalStatusFilter] = useState(statusFilter);

  // ✅ Sync with prop changes
  useEffect(() => {
    setLocalStatusFilter(statusFilter);
  }, [statusFilter]);

  const handleStatusChange = (e: any) => {
    const value = e?.target?.value || e;
    setLocalStatusFilter(value);
    onStatusFilterChange(value);
  };

  return (
    <div className="w-full mx-auto px-4">
      <div className="mt-4 w-full px-5 min-h-[60px] mb-3 flex items-center justify-end gap-4 ">
        <div className="w-full flex flex-wrap justify-between gap-2 p-2">
          <FilterSelect
            selectedOption={selectedOption}
            handleFilterChange={handleFilterChange}
          />
          <ExportSelect
            orders={orders}
            selectedDate={selectedDate}
            selectedDate2={selectedDate2}
            handleExport={handleExport}
          />
          <ImportButton inputRef={inputRef} handleImport={handleImport} />
          {/* <div className='w-40'>
            <p>Status Filter</p>
            <CustomDropdownSelect
              name='statusSelected'
              value={localStatusFilter}
              titleofSelect='All Status'
              options={STATUS_OPTIONS.map((o) => ({
                _id: o,
                CategoryName: o,
              }))}
              onChange={handleStatusChange}
            />
          </div> */}
          <SearchField searchTerm={searchTerm} handleSearch={handleSearch} />
        </div>
      </div>
    </div>
  );
};

export default OrdersToolbar;
